import { DayOfWeek } from '@leid/api-locations'

export const buildUtcDateString = (date: Date | null, hours: string | null): string => {
  const result = buildDate(date, hours).toISOString()
  return result
}

export const buildDate = (date: Date | null, hours: string | null): Date => {
  const result = new Date(`${date?.toDateString()} ${hours ?? '00'}:00:00`)
  return result
}

export const utcNow = (): Date => {
  return new Date()
}

export const parseDayOfWeek = (dayNumber: number): DayOfWeek => {
  switch (dayNumber) {
    case 0:
      return DayOfWeek.SUNDAY
    case 1:
      return DayOfWeek.MONDAY
    case 2:
      return DayOfWeek.TUESDAY
    case 3:
      return DayOfWeek.WEDNESDAY
    case 4:
      return DayOfWeek.THURSDAY
    case 5:
      return DayOfWeek.FRIDAY
    case 6:
      return DayOfWeek.SATURDAY
  }

  return DayOfWeek.MONDAY
}

export const transformHoursToTwoDigitsString = (hours: number): string => {
  return hours < 10 ? `0${hours}` : hours.toString()
}
